<template>
    <div id="logo" class="container h-100 d-flex justify-content-center">
        <div class="col-12 my-auto text-center">
            <img src="../public/logo/codekings-logo-white.png" alt="CodeKings OÜ logo">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CodeKings'
    };
</script>

<style lang="scss">
    html, body {
        height: 100% !important;
        background-color: #0c0c38 !important;
    }

    #logo {
        img {
            height: 250px;
        }
    }
</style>
